<template>
  <div class="my-editor">
    <div ref="editor" class="editor-wrapper"></div>
  </div>
</template>

<script>
import WEditor from "wangeditor";
import config from "@/config";

// 富文本编辑器
export default {
  name: "Editor",
  props: {
    value: {
      default: undefined,
    },
    isClear: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editor: undefined,
      editorHtml: undefined,
    };
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear();
      }
    },
    value(val) {
      if (val !== this.editorHtml) {
        this.editorHtml = val;
        if (val) {
          this.editor.txt.html(val);
        } else {
          this.editor.txt.clear();
        }
      }
    },
    disabled(val) {
      this.editor.$textElem.attr("contenteditable", !this.disabled);
    },
  },
  mounted() {
    this.initEditor();
  },
  methods: {
    getText() {
      this.editor.txt.text();
    },
    setText(val) {
      this.editor.txt.html(val);
    },
    getHtml() {
      this.editor.txt.html();
    },
    initEditor() {
      this.editor = new WEditor(this.$refs.editor);
      this.editor.config.height = 300;
      this.editor.config.zIndex = 0;
      this.editor.config.placeholder = "";
      this.editor.config.focus = false; // 取消自动 focus
      this.editor.config.uploadImgShowBase64 = false; // base 64 存储图片
      this.editor.config.showLinkImg = false; // 关闭通过图片地址添加图片
      this.editor.config.uploadImgServer = config.apiUploadUrlWX; // 配置上传图片服务器地址
      // this.editor.config.uploadImgParams ={
      //   openId: this.$route.query.openid,
      // }
      // const header = {}
      // header[tokenName] = getToken()
      // this.editor.config.uploadImgHeaders = header // 自定义 header
      this.editor.config.uploadFileName = "file"; // 后端接受上传文件的参数名
      this.editor.config.uploadImgMaxSize = 5 * 1024 * 1024; // 将图片大小限制为 5M
      this.editor.config.uploadImgMaxLength = 5; // 限制一次最多上传 5 张图片
      this.editor.config.uploadImgTimeout = 60 * 1000; // 设置超时时间


      // ============ 新增：视频上传配置 ============
      this.editor.config.uploadVideoServer = config.apiUploadUrlWX; // 视频上传地址（可以与图片相同）
      this.editor.config.uploadVideoName = "file"; // 后端接收视频文件的参数名

      this.editor.config.uploadVideoParams = {
        // fileName: null,
        openId:this.$route.query.openid
      }


      this.editor.config.uploadVideoMaxSize = 50 * 1024 * 1024; // 50M，视频通常比图片大
      this.editor.config.uploadVideoTimeout = 180 * 1000; // 3分钟，视频上传需要更长时间
      // this.editor.config.uploadVideoHeaders = {
      //   // 如果需要token验证
      //   Authorization: `Bearer ${getToken()}`,
      //   'X-Requested-With': 'XMLHttpRequest'
      // };
      this.editor.config.uploadVideoAccept = [
        'mp4',
        'avi',
        'mov',
        'wmv',
        'flv',
        'webm'
      ]; // 允许的视频格式

      // 视频上传钩子函数
      this.editor.config.uploadVideoHooks = {
        // 上传视频之前
        before: (file) => {
          //
          // console.log('before hook file:', file); // 先检查参数结构
          // console.log('file type:', typeof file);
          // console.log('file keys:', Object.keys(file || {}));
          // this.editor.config.uploadVideoParams.fileName = file.name;
          // this.editor.config.uploadVideoParams.openId = this.$route.query.openid;


          return true; // 返回true才会继续上传
        },

        // 视频上传并返回结果
        success: (xhr, editor, result) => {
          // console.log('视频上传成功', result);
          // this.$message.success('视频上传成功！');
        },

        // 视频上传出错
        fail: (xhr, editor, result) => {
          console.error('视频上传失败', result);
          this.$message.error('视频上传失败：' + (result.message || '未知错误'));
        },

        // 视频上传出错（网络错误）
        error: (xhr, editor) => {
          console.error('视频上传发生错误');
          this.$message.error('视频上传发生网络错误');
        },

        // 视频上传超时
        timeout: (xhr, editor) => {
          console.error('视频上传超时');
          this.$message.error('视频上传超时，请检查网络或文件大小');
        },

        // 自定义插入视频（关键！）
        customInsert: (insertVideoFn, result) => {
          // result 是服务端返回的数据
          // 根据您的后端返回结构调整获取视频URL的方式
          let videoUrl = '';

          if (result.data && result.data.url) {
            videoUrl = result.data.url;
          } else if (result.url) {
            videoUrl = result.url;
          } else if (result.msg) {
            videoUrl = result.msg; // 兼容您图片上传的返回格式
          }

          if (videoUrl) {
            // 插入视频到编辑器
            insertVideoFn(videoUrl);
          } else {
            this.$message.error('无法获取视频地址');
          }
        }
      };
      // ============ 视频配置结束 ============


      this.editor.config.emotions = [
        {
          // tab 的标题
          title: "表情",
          // type -> 'emoji' / 'image'
          type: "emoji",
          content: [
            "😀",
            "😃",
            "😄",
            "😁",
            "😆",
            "🤣",
            "😄",
            "😅",
            "😆",
            "😉",
            "😊",
            "😋",
            "😎",
            "😍",
            "😘",
            "😗",
            "😚",
            "🙂",
            "🤗",
            "🤔",
            "😳",
            "😑",
            "😶",
            "🙄",
            "😏",
            "😣",
            "😥",
            "😮",
            "🤐",
            "😯",
            "😪",
            "😫",
            "😴",
            "😌",
            "😛",
            "😜",
            "😒",
            "😓",
            "😕",
            "🙃",
            "😲",
            "🙁",
            "😖",
            "😤",
            "😭",
            "😨",
            "😬",
            "😱",
            "😡",
            "😠",
            "😷",
            "🤒",
            "🤧",
            "🤡",
            "😈",
            "💀",
            "👻",
            "👽",
            "💩",
            "😺",
            "😸",
            "😹",
            "😻",
            "😼",
            "😽",
            "🙀",
            "😿",
            "😾",
            "💖",
            "💗",
            "💟",
            "💤",
            "💢",
            "👈",
            "👉",
            "☝",
            "👆",
            "✌",
            "👌",
            "👍",
            "👌",
            "👎",
            "✊",
            "🤛",
            "🤜",
            "👏",
            "🙏",
            "🤝",
            "🌹",
            "🥀",
          ],
        },
      ];
      // // 配置菜单 可根据文档进行添加
      this.editor.config.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
      ];

      this.editor.config.uploadImgHooks = {
        before: (xhr, editor, files) => {
          // files 是上传的文件数组
          // if (files && files.length > 0) {
            const fileName = files[0].name;
            // 动态添加到上传参数
            this.editor.config.uploadImgParams.fileName = fileName;
            this.editor.config.uploadImgParams.openId = this.$route.query.openid;
          return true; // 返回true才会继续上传
          // }
        },
        fail: (xhr, editor, result) => {
          // 图片上传并返回结果，但图片插入错误时触发
          this.$message({
            message: "图片插入失败！",
            type: "error",
          });
        },
        error: function (xhr, editor) {
          // 图片上传出错时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
          this.$message({
            message: "图片上传失败！",
            type: "error",
          });
        },
        timeout: (xhr, editor) => {
          // 图片上传超时时触发
          this.$message({
            message: "图片上传超时，请检查网络！",
            type: "error",
          });
        },
        customInsert: (insertImg, data, editor) => {
          const url = data.msg;
          insertImg(url);
        },
      };
      // 将内容同步到父组件中
      this.editor.config.onchange = (html) => {
        this.editorHtml = html;
        this.$emit("update:value", html);
      };
      this.editor.config.zIndex = 0; // 配置富文本的权重 不然会覆盖其他组件
      // 创建富文本编辑器
      this.editor.create();
      // 初始化值
      if (this.value) {
        this.editorHtml = this.value;
        this.editor.txt.html(this.value);
      }
      this.editor.$textElem.attr("contenteditable", !this.disabled);
    },
  },
};
</script>


<style lang="scss" scoped>
.my-editor {
  .editor-wrapper {
    text-align: left;
  }
}
</style>
